/**
 * Background colours for badges that carry WHITE text.
 *
 * Found 2026-10-05 by the first axe scan of the signed-in product (staging): the glossary and
 * snippet badges, among others, used Tailwind's 500 shades with white text — green 2.53:1,
 * amber 2.14:1, blue 3.67:1, red 3.76:1, pink 3.52:1, violet 4.23:1, all below WCAG AA's 4.5:1.
 * Each page carried its own hand-copied map of the same five colours, so the fix is one palette,
 * held to 4.5:1 against white by `badgeColors.test.ts`.
 *
 * The 700 shades keep the hue a child recognises ("green is beginner") and clear 4.5:1 with room.
 */
export const BADGE = {
  green: '#047857',
  blue: '#1d4ed8',
  violet: '#6d28d9',
  red: '#b91c1c',
  amber: '#b45309',
  pink: '#be185d',
  cyan: '#0e7490',
  teal: '#0f766e',
  yellow: '#a16207',
} as const;

export type BadgeColor = (typeof BADGE)[keyof typeof BADGE];
